/* istanbul ignore file */

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { keyframes } from 'styled-components';

type KeyframeType = ReturnType<typeof keyframes>;

export const applyKeyframe = (keyframe: KeyframeType) => () =>
  process.env.NODE_ENV === 'test' ? keyframe.getName() : keyframe;
